import { createTheme, ThemeProvider } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { FormControl } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import * as React from 'react';
import { useSelector } from 'react-redux';
import FieldNames from '../../../defaults/FieldNames.json';
import { getFieldStyle } from '../../../utils/ValidationHelper';

const useStyles = makeStyles({
  underline: {
    "&&&:before": {
      borderBottom: "2px solid red"
    },
    "&&:after": {
      borderBottom: "2px solid red"
    }
  }
});

const useNotSavedStyles = makeStyles({
  underline: {
    "&&&:before": {
      borderBottom: "2px solid gold"
    },
    "&&:after": {
      borderBottom: "2px solid gold"
    }
  }
});

const theme = createTheme({
  overrides: {
    
  },
});

export default function DetailsYearPicker({detail, field, onFieldChange, isRequired, allFields, isActuals}) {
  const [datePickerValue, setDatePickerValue] = React.useState();
  const classes = useStyles();
  const notSavedClasses = useNotSavedStyles();

  const [currentError, setCurrentError] = React.useState("");
  const [toShowError, setToShowError] = React.useState(false);
  const [isReadOnly, setIsReadOnly] = React.useState(false);
  const treatmentValidationUnsavedValues = useSelector((state) => { return state.treatmentValidation });
  const activityValidationUnsavedValues = useSelector((state) => { return state.activityValidation });
  const actualsTreatmentValidationUnsavedValues = useSelector((state) => { return state.actualsTreatmentValidation });
  const actualsActivityValidationUnsavedValues = useSelector((state) => { return state.actualsActivityValidation });

  React.useEffect(() => {
      // The fix will be to be sure that all dates like: 2023-10-9 have a 0 in front of the day
      if(detail && detail.attributes && detail.attributes[field]){
        //Need to do this for the sake of the date picker.  We don't care since we only save the year
        const newDateWithCorrectYear = new Date(detail.attributes[field], 1);
        setDatePickerValue(newDateWithCorrectYear);
      } else {
        setDatePickerValue(null)
      }
  
      if(isActuals){
        setIsReadOnly(true);
      } 
    }, [detail, field, allFields, isActuals]);

  const handleChange = (value) => {
    const year = value?.getFullYear();
    if(!year){
      setCurrentError("");
      setToShowError(false);
      onFieldChange(field, null);
    } 
    // else if(detail?.attributes && year < detail.attributes[FieldNames.featureFields.originalInitiationFiscalYear]){
    //   setCurrentError(`Cannot be before ${detail.attributes[FieldNames.featureFields.originalInitiationFiscalYear]}`);
    //   setToShowError(true);
    // } 
    else {
      const dateErrString = isValidYearValue(field, year, isActuals, detail, allFields);
      if(dateErrString === "")
      {
        onFieldChange(field, year);
        setCurrentError("");
        setToShowError(false);
      } else
      {
        setCurrentError(dateErrString);
        setToShowError(true);
      }
    }
  }

  const isValidYearValue = (field, value, isActuals, detail, allFields) => {
    var isActual = isActuals;
    var originalInitiationFY = detail.attributes[FieldNames.featureFields.originalInitiationFY];
  
    var isFourDigitYear = /^\d{4}$/.test(value);
    if (!isFourDigitYear) {
      return "The date year must be 4 digits.";
    }
    // Initiation/Completion date validation
    if (field === allFields.initiationDate && !isActual && originalInitiationFY
      && value < originalInitiationFY) {
      return `Cannot be before ${detail.attributes[FieldNames.featureFields.originalInitiationFY]}`;
    }
  
    return "";
  }

  return (
    <FormControl variant="standard" fullWidth>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            fullWidth
            clearable
            clearText="Clear"
            openTo="year"
            views={['year']}
            disabled={isReadOnly}
            value={datePickerValue}
            onChange={(newValue) => handleChange(newValue)}
            slotProps={{
              textField: { variant: 'standard', clearable: true, fullWidth: true, error: toShowError, helperText: toShowError ? currentError ?? '' : undefined, InputProps: {fullWidth: true, classes: getFieldStyle(isRequired, detail, field, classes, notSavedClasses, treatmentValidationUnsavedValues, actualsTreatmentValidationUnsavedValues, activityValidationUnsavedValues, actualsActivityValidationUnsavedValues)}},
            }}
            onError={(reason, value) => {
              switch (reason) {
                case "maxDate":
                  setToShowError(true);
                  setCurrentError(`Date should not be after ${formatDateForDisplay(new Date)}`)
                  break;
                case null:
                  setToShowError(false);
                  setCurrentError("");
                  break;
                default:
                  break;
              }
            }}
          />
        </LocalizationProvider>
      </ThemeProvider>
    </FormControl>
  );
}